import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { registerUser, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateUserData } from "../../store/appSlice";

export default function UserProfileSetup() {
  pageTitle("Complete Registration");

  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.appSlice.userData);
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState("IN");
  const [gender, setGender] = useState(1);
  const [mobile, setMobile] = useState("");
  const [dob, setDob] = useState(new Date());

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData?.phone_number) {
      navigate("/profile");
    }
  }, [userData, navigate]);

  const mapCountries = countries.map((it) => ({ label: it.country_name, value: it.phone_code }));

  const onSelectCountryItem = (c) => {
    setSelectedCountry(c);
  };
  const handleSubmitClick = async () => {
    if (mobile === "") {
      toast.error("Mobile number is required");
      return;
    }
    if (!selectedCountry) {
      toast.error("Country is required");
      return;
    }
    if (!dob) {
      toast.error("Date of birth is is required");
      return;
    }
    if (mobile != "" && mobile.length < 8) {
      toast.error("Invalid mobile number");
      return;
    }
    const payload = {
      identity: userData.identity,
      phone_number: `${mobile} ${selectedPhoneCountry}`,
      country_code: selectedCountry,
      gender: gender,
      dob: getYYYYmmddFromDate(dob),
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(updateUserDetais, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("User details has been updated.");
        dispatch(updateUserData(response?.data?.data));
        navigate("/");
      } else {
        toast.error(response.data?.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Section topMd={60} topLg={150} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 mx-auto justify-content-center">
          <div className="col-12 col-md-6 g-2 mx-auto">
            {/* <img className="img-fluid w-25 h-25 m-3" src="/images/logo.svg" /> */}
            <PageHeader title={"Complete Registration"} />
            <p className="fs-md text-grey2 p-2"></p>
            <MobileNumberWithCountryCode selectedPhoneCountry={selectedPhoneCountry} onChange={setSelectedPhoneCountry} mobile={mobile} onMobileChange={setMobile} />
            <SelectField2 defaultValue={selectedCountry} label={"Select Country"} placeholder={"Select a country"} items={mapCountries} onChange={onSelectCountryItem} />
            <SelectField
              defaultValue={gender}
              label={"Select Gender"}
              items={[
                { label: "Male", value: 1 },
                { label: "Female", value: 0 },
              ]}
              onChange={(e) => setGender(e.target.value)}
            />

            <div className="bg-transparent bg-grey2 position-relative w-100 mb-5">
              <span className="fs-normal text-muted mb-2 d-block">Date of Birth</span>
              <div className="position-relative w-100">
                <DatePicker className="bg-transparents" selected={dob} onChange={setDob} />
                <img className="position-absolute end-0" style={{ height: 15, width: 15, top: "26%", marginRight: 10 }} src="/images/icons/ic_calender.png" alt="calendar icon" />
              </div>
            </div>
            <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={loading} />
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
